import './ReusableTable.scss';

function ReusableTable(props) {
  const headers = props.header;
  const body = props.body;

  function formattedDate(date) {
    const d = new Date(date);
    const formatted = d
      .toLocaleDateString("en-US", { month: "long", year: "numeric" })
      .replace(",", "");

    return formatted;
  }

  return (
    <table className="product-download-table">
      <thead>
        <tr>
          {headers.length > 0 ? (
            headers.map((title, index) => (
              <th className="product-header" key={index}><span>{title}</span></th>
            ))
          ) : null}
        </tr>
      </thead>
      <tbody>
        {body.length > 0 ? (
          body.map((product) => (
            <tr key={product.productId}>
              <td className="product-column">{product.productName}</td>
              <td className="product-column">{formattedDate(product.renewalDate)}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={headers.length}>No subscriptions found.</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
export default ReusableTable;